import useAntTable from "../../../../utils/useAntTable";
import PageHeaderLayout from "../../../../layout/pageHeaderLayout";
import StandardTable, {StandardColumnsType} from "../../../../components/StandardTable";
import {Input, InputNumber} from "antd";
import * as api from "../../../../apis/platforms/admin/contractGiveawayRemain";
import BaseDataDisplay from "../../../../components/BaseDataSelect/display";
import ModifyModal from "./modifyModal";
import useFormModal from "../../../../utils/useFormModal";
import withAuth from "../../../../utils/withAuth";
import {Fragment} from "react";

const EditFragment = withAuth('modify', Fragment)

function ContractGiveawayRemain(props: any) {

    const {tableProps, refresh, form, search} = useAntTable(api.getRemain, {});


    const {modalProps, setVisible} = useFormModal({
        onRequest: api.modifyGiveawayRemain,
        onOk: () => {
            refresh()
            setVisible(false)
        }
    })

    const columns: StandardColumnsType = [
        {
            dataIndex: 'dealerName',
            title: '客户名称',
        },
        {
            dataIndex: 'group',
            title: '集团名称',
            render: (value) => <BaseDataDisplay name={'groups'} value={value}/>
        },
        {
            dataIndex: 'contractCode',
            title: '合同编号',
        },
        {
            dataIndex: 'productCode',
            title: '产品编号',
        },
        {
            dataIndex: 'productName',
            title: '产品名称'
        },
        {
            dataIndex: 'giveawayCode',
            title: '赠品编号',
        },
        {
            dataIndex: 'giveawayName',
            title: '赠品名称'
        },
        {
            dataIndex: 'remainQty',
            title: '赠品余量'
        },
        {
            dataIndex: 'operations',
            title: '操作',
            render: (_, record: any) => (
                <span>
                    <EditFragment>
                        <a onClick={() => setVisible(true, record)}>编辑</a>
                    </EditFragment>
                </span>
            )
        }
    ];

    const searchColumns: StandardColumnsType = [
        {
            dataIndex: 'dealer',
            title: '',
            search: {
                valueRender: <Input placeholder={'请输入客户/集团名称'}></Input>,
                colSpan: 6
            }
        },
        {
            dataIndex: 'product',
            title: '',
            search: {
                valueRender: <Input placeholder={'请输入产品名称/编号'}></Input>,
                colSpan: 6
            }
        },
    ];

    return <PageHeaderLayout>
        <StandardTable rowKey={'id'} form={form} search={search} columns={columns} extSearchColumns={searchColumns} {...tableProps}/>
        <ModifyModal {...modalProps} />
    </PageHeaderLayout>
}

export default ContractGiveawayRemain;
